import { defineComponent as _defineComponent } from 'vue'
import { toastServiceError } from '@/services/core/notification';
import WorkScheduleService from '@/services/api/WorkScheduleService';
import { useUiStore } from '@/stores';
import { Permission, ScheduleWeekday, WorkScheduleModel } from '@/types';
import { computed, onMounted, ref, Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkScheduleDetailPage',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const uiStore = useUiStore();
const { t } = useI18n();

const workSchedule: Ref<WorkScheduleModel | undefined> = ref(undefined);

const weekdays: ScheduleWeekday[] = [
    ScheduleWeekday.SUNDAY,
    ScheduleWeekday.MONDAY,
    ScheduleWeekday.TUESDAY,
    ScheduleWeekday.WEDNESDAY,
    ScheduleWeekday.THURSDAY,
    ScheduleWeekday.FRIDAY,
    ScheduleWeekday.SATURDAY,
];

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchWorkScheduleById = async (id: number) => {
    try {
        setLoading(true);
        const { data } = await WorkScheduleService.get<WorkScheduleModel>(id);
        workSchedule.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const workDays = computed(() =>
    weekdays.filter((day: ScheduleWeekday) => workSchedule.value?.[day]),
);

const formatDayLabel = (day: ScheduleWeekday) => t('schedule.labels.' + day.toLocaleLowerCase());

onMounted(() => {
    const id = Number(route.params.id);
    if (!isNaN(id)) fetchWorkScheduleById(id);
});

const __returned__ = { route, uiStore, t, workSchedule, weekdays, setLoading, fetchWorkScheduleById, workDays, formatDayLabel, get Permission() { return Permission } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})